// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2Q3_E","label":"Completed_label__3bOtQ"};